import { StringMap } from './types';

export const back: string = '🂠';

export const jokers: StringMap = {
    rj: '🂿',
    bj: '🃏',
    wj: '🃟',
};

export const deck: StringMap = {
    as: '🂡',
    ah: '🂱',
    ad: '🃁',
    ac: '🃑',
    '2s': '🂢',
    '2h': '🂲',
    '2d': '🃂',
    '2c': '🃒',
    '3s': '🂣',
    '3h': '🂳',
    '3d': '🃃',
    '3c': '🃓',
    '4s': '🂤',
    '4h': '🂴',
    '4d': '🃄',
    '4c': '🃔',
    '5s': '🂥',
    '5h': '🂵',
    '5d': '🃅',
    '5c': '🃕',
    '6s': '🂦',
    '6h': '🂶',
    '6d': '🃆',
    '6c': '🃖',
    '7s': '🂧',
    '7h': '🂷',
    '7d': '🃇',
    '7c': '🃗',
    '8s': '🂨',
    '8h': '🂸',
    '8d': '🃈',
    '8c': '🃘',
    '9s': '🂩',
    '9h': '🂹',
    '9d': '🃉',
    '9c': '🃙',
    '10s': '🂪',
    '10h': '🂺',
    '10d': '🃊',
    '10c': '🃚',
    js: '🂫',
    jh: '🂻',
    jd: '🃋',
    jc: '🃛',
    kns: '🂬',
    knh: '🂼',
    knd: '🃌',
    knc: '🃜',
    qs: '🂭',
    qh: '🂽',
    qd: '🃍',
    qc: '🃝',
    ks: '🂮',
    kh: '🂾',
    kd: '🃎',
    kc: '🃞',
};

export const trumps: string[] = [
    '🃠', // Fool
    '🃡', // Trump-1 (individual)
    '🃢', // Trump-2 (childhood)
    '🃣', // Trump-3 (youth)
    '🃤', // Trump-4 (maturity)
    '🃥', // Trump-5 (old age)
    '🃦', // Trump-6 (morning)
    '🃧', // Trump-7 (afternoon)
    '🃨', // Trump-8 (evening)
    '🃩', // Trump-9 (night)
    '🃪', // Trump-10 (earth and air)
    '🃫', // Trump-11 (water and fire)
    '🃬', // Trump-12 (dance)
    '🃭', // Trump-13 (shopping)
    '🃮', // Trump-14 (open air)
    '🃯', // Trump-15 (visual arts)
    '🃰', // Trump-16 (spring)
    '🃱', // Trump-17 (autumn)
    '🃲', // Trump-18 (winter)
    '🃳', // Trump-19 (individual)
    '🃴', // Trump-20 (the game)
    '🃵', // Trump-21 (collective)
];
